import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, onBeforeUnmount, defineAsyncComponent, getCurrentInstance } from 'vue';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
// Config
import { FEATURE_FLAGS } from '@white-label-configuration/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'loading-screen',
  props: {
  isLoading: {
    type: Boolean,
    default: false
  },
  duration: {
    type: Number,
    default: 10000
  },
},
  emits: ['loaded'],
  setup(__props, { emit }) {

const props = __props;

const instance = getCurrentInstance();
const vm = instance?.proxy as Vue;

const IconCheck = defineAsyncComponent(() => import('@white-label-icon/icon-check'));





const progress = ref(0);
const interval = ref<number | null>(null);
const currentStep = ref(0);
const completedSteps = ref(0);
const pause = ref(false);

const isReviewsEnabled = computed(
  () =>
    !!getAppVariable('review_providers[0].is_enabled') &&
    getFeatureFlag(FEATURE_FLAGS.WL_PRODUCT_CARD_REVIEW_STARS) === true
);

const stepProgressInterval = computed(() => 100 / 4);

const merchantId = computed(() => getAppVariable('review_providers[0].merchant_id'));

const loadingSteps = computed(() => {
  const steps = [
    vm.$t('loadingScreen.step1'),
    vm.$t('loadingScreen.step2'),
    vm.$t('loadingScreen.step3'),
  ];
  if (isReviewsEnabled.value) {
    steps.push(vm.$t('loadingScreen.step4'))
  }
  return steps;
})

const startAnimation = () => {
  if (interval.value !== null) {
    clearInterval(interval.value);
  }

  if (!pause.value && !progress.value) {
    progress.value = 0;
    currentStep.value = 0;
    completedSteps.value = 0;
  } else if (pause.value) {
    progress.value = 99;
    currentStep.value = 3;
    completedSteps.value = 3;
  }

  const intervalDuration = 50;
  const progressStep = (100 / props.duration) * intervalDuration;

  interval.value = window.setInterval(() => {
    if (progress.value >= 100) {
      progress.value = 100;
      stopAnimation();
      return;
    }

    if (progress.value >= 99 && props.isLoading) {
      progress.value = 99;
      stopAnimation();
      pause.value = true;
      return;
    }

    progress.value += progressStep;

    const stepIndex = Math.floor(progress.value / stepProgressInterval.value);
    if (stepIndex !== currentStep.value) {
      currentStep.value = stepIndex;
      completedSteps.value = stepIndex;
    }
  }, intervalDuration);
};

const stopAnimation = () => {
  if (interval.value !== null) {
    clearInterval(interval.value);
    interval.value = null;
  }
};

watch(() => props.isLoading, (newVal) => {
  if (!newVal) {
    startAnimation();
    completedSteps.value = 4;
    progress.value = 100;
  } else {
    stopAnimation();
  }
});

watch(progress, (newValue) => {
  if (newValue === 100) {
    setTimeout(() => {
      emit('loaded', true);
    }, 1000);
  }
});

onMounted(() => {
  startAnimation();
});

onBeforeUnmount(() => {
  stopAnimation();
});

return { __sfc: true,instance, vm, IconCheck, props, emit, progress, interval, currentStep, completedSteps, pause, isReviewsEnabled, stepProgressInterval, merchantId, loadingSteps, startAnimation, stopAnimation }
}

})